import React from "react";
import { TechIcons } from "../common/misc";

const PortfolioSpecs = ({ name, info }) => {
  return (
    <div className="row project-specs">
      <div className="col-md-4 name">
        <p>{name}</p>
      </div>
      <div className="col-md-8 info">
        {!Array.isArray(info) ? (
          <p>{info}</p>
        ) : (
          info.map((info, i) => (
            <TechIcons name={info} key={`tech-logo-${i}`} />
          ))
        )}
      </div>
    </div>
  );
};

export default PortfolioSpecs;
